import axios from "axios";
import { APIHost } from "./helpers";

// Base URL
export const baseURL = () => {
  return APIHost() + "/grader/order";
  // return "http://192.168.1.16:3301/grader/order"
};

// Base URL
export const vendingURL = () => {
  return APIHost() + "/vending/grader/order";
  // return "http://192.168.1.12:3301/vending/grader/zone"
};


export const getSettlementStatus = data => {
  const url = `${baseURL()}/settlement/status`;
  return axios.post(url, data);
};


export const scanUserQRcode = data => {
  const url = `${baseURL()}/dumpExpress/scanUserQRcode`;
  return axios.post(url, data);
};

export const startGrading = data => {
  const url = `${vendingURL()}/dumpExpress/startGrading`;
  return axios.post(url, data);
};


/* ===== WALK IN ORDER  ===== */
export const placeWalkInOrder = data => {
  const url = `${baseURL()}/dumpExpress/placeOrderWeb`;
  return axios.post(url, data);
};

export const getPendingWalkInOrder = data => {
  const url = `${baseURL()}/dumpExpress/pending`;
  return axios.post(url, data);
};

export const cancelWalkInOrder = (id, data) => {
  const url = `${vendingURL()}/dumpExpress/cancel/${id}`;
  return axios.post(url, data);
};

export const setWalkInOrderPaymentMethod = (id, data) => {
  const url = `${baseURL()}/dumpExpress/paymentMethod/${id}`;
  return axios.post(url, data);
};

export const completeWalkInOrder = (id, data) => {
  const url = `${vendingURL()}/dumpExpress/complete/${id}`;
  return axios.post(url, data);
};

export const gradeAgainCompletedWalkInOrder = (id, data) => {
  const url = `${vendingURL()}/dumpExpress/gradeAgain/${id}`;
  return axios.post(url, data);
};

export const cancelCompletedWalkInOrder = (id, data) => {
  const url = `${baseURL()}/dumpExpress/updCancel/${id}`;
  return axios.post(url, data);
};

export const walkInOrderDetail = (id, data) => {
  const url = `${baseURL()}/dumpExpress/detail/${id}`;
  return axios.post(url, data);
};

export const addWalkInOrderRecycling = (id, data) => {
  const url = `${vendingURL()}/dumpExpress/recycling/add/${id}`;
  return axios.post(url, data);
};

export const updateWalkInOrderRecycling = (id, recycling, data) => {
  const url = `${vendingURL()}/dumpExpress/recycling/update/${id}/${recycling}`;
  return axios.post(url, data);
};

export const removeWalkInOrderRecycling = (id, data) => {
  const url = `${vendingURL()}/dumpExpress/recycling/remove/${id}`;
  return axios.post(url, data);
};

export const walkInOrderSetZone = (id, data) => {
  const url = `${baseURL()}/dumpExpress/setZone/${id}`;
  return axios.post(url, data);
};

export const walkInOrderCategorySetZone = (id, data) => {
  const url = `${baseURL()}/dumpExpress/categorySetZone/${id}`;
  return axios.post(url, data);
};
/* ===== WALK IN ORDER  ===== */


export const loadOrderHistoryCount = data => {
  const url = `${baseURL()}/count`;
  return axios.post(url, data);
};

export const loadOrderHistoryList = data => {
  const url = `${baseURL()}/list`;
  return axios.post(url, data);
};

export const loadOrderHistoryDetail = (id, data) => {
  const url = `${baseURL()}/detail/${id}`;
  return axios.post(url, data);
};


/* ===== DUMPEXPRESS TASK  ===== */
export const loadDumpExpressTaskList = (data) => {
  const url = `${baseURL()}/dumpExpress/task/load`;
  return axios.post(url, data);
};


export const acceptDumpExpressTask = (id, data) => {
  const url = `${baseURL()}/dumpExpress/task/accept/${id}`;
  return axios.post(url, data);
};


export const rejectDumpExpressTask = (id, data) => {
  const url = `${baseURL()}/dumpExpress/task/reject/${id}`;
  return axios.post(url, data);
};

/* ===== DUMPEXPRESS TASK  ===== */

/* ===== GRADING TASK  ===== */
export const loadGradingTaskList = (data) => {
  const url = `${baseURL()}/dumpRecycling/load`;
  return axios.post(url, data);
};


export const loadGradingTaskDetail = (id, data) => {
  const url = `${baseURL()}/dumpRecycling/detail/${id}`;
  return axios.post(url, data);
};


export const acceptGradingTask = (id, data) => {
  const url = `${baseURL()}/dumpRecycling/accept/${id}`;
  return axios.post(url, data);
};


export const rejectGradingTask = (id, data) => {
  const url = `${baseURL()}/dumpRecycling/reject/${id}`;
  return axios.post(url, data);
};


export const gradingTaskSetZone = (id, data) => {
  const url = `${baseURL()}/dumpRecycling/setZone/${id}`;
  return axios.post(url, data);
};

export const gradingTaskCategorySetZone = (id, data) => {
  const url = `${baseURL()}/dumpRecycling/categorySetZone/${id}`;
  return axios.post(url, data);
};


export const addGradingTaskRecycling = (id, data) => {
  const url = `${baseURL()}/dumpRecycling/recycling/add/${id}`;
  return axios.post(url, data);
};


export const updateGradingTaskRecycling = (id, recycling, data) => {
  const url = `${baseURL()}/dumpRecycling/recycling/update/${id}/${recycling}`;
  return axios.post(url, data);
};


export const removeGradingTaskRecycling = (id, data) => {
  const url = `${baseURL()}/dumpRecycling/recycling/remove/${id}`;
  return axios.post(url, data);
};


export const uploadGradingTaskDocument = (id, data) => {
  const url = `${baseURL()}/dumpRecycling/uploadDoc/${id}`;
  return axios.post(url, data);
};


export const completeGradingTask = (id, data) => {
  const url = `${baseURL()}/dumpRecycling/complete/${id}`;
  return axios.post(url, data);
};

export const GradingTaskScanQR = (data) => {
  const url = `${baseURL()}/dumpRecycling/scanQR`;
  return axios.post(url, data);
};
/* ===== GRADING TASK  ===== */


/* ===== DUMPWASTE GRADING TASK  ===== */
export const loadWasteGradingTaskList = (data) => {
  const url = `${baseURL()}/dumpWaste/load`;
  return axios.post(url, data);
};


export const loadWasteGradingTaskDetail = (id, data) => {
  const url = `${baseURL()}/dumpWaste/detail/${id}`;
  return axios.post(url, data);
};


export const uploadWasteGradingTaskDocument = (id, data) => {
  const url = `${baseURL()}/dumpWaste/uploadDoc/${id}`;
  return axios.post(url, data);
};


export const completeWasteGradingTask = (id, data) => {
  const url = `${baseURL()}/dumpWaste/complete/${id}`;
  return axios.post(url, data);
};
/* ===== DUMPWASTE GRADING TASK  ===== */


export const registerUser = (data) => {
  const url = `${baseURL()}/registerUser`;
  return axios.post(url, data);
};

export const checkUserExist = (data) => {
  const url = `${baseURL()}/checkUserExist`;
  return axios.post(url, data);
};

export const getDumpRecyclingDRVMOrder = (id, data) => {
  const url = `${baseURL()}/dumpRecycling/DRVMOrder/${id}`;
  return axios.post(url, data);
};